<template>
  <div id="checkinRecord" class="container">
    <div class="check-tab">
      <CheckInTab :tabInit="tabInit"></CheckInTab>
    </div>
    <div class="checkin-wrap">
      <a-form :form="form" layout="inline">
        <a-row>
          <a-col :span="8">
            <a-form-item
              label="出发城市"
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }"
            >
              <air-flight-city-selector
                type="single"
                :data-source="citiesData"
                @change="onDepCodeChange"
                placeholder="出发城市"
              >
              </air-flight-city-selector>
              <a-input
                hidden
                v-decorator="[
                    'depCode',
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                placeholder="请输入起飞城市"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              label="旅客姓名"
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }"
            >
              <a-input
                v-decorator="[
                    'passengerName',
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                placeholder="请输入旅客姓名"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item
              label="凭证号码"
              :label-col="{ span: labelWidth }"
              :wrapper-col="{ span: wrapWidth }"
            >
              <a-input
                v-decorator="[
                    'ticketNo',
                    {
                      rules: [
                        {
                          validator: handleFieldValidate
                        }
                      ],
                      validateTrigger: 'blur'
                    }
                  ]"
                :placeholder="`请输入票号，如${ticketCode}1234567890`"
              >
              </a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item class="btn-center" align="right">
              <a-button type="primary" html-type="submit" size="default" @click="handleSubmit">查询</a-button>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div v-if="isSearch">
        <a-spin class="loading" v-if="loading" tip="查询中..." />
        <a-table
          v-else
          rowKey="id"
          :columns="columns"
          :dataSource="data.list"
          :pagination="data.pagination"
          @change="onChange"
        >
          <span slot="boardingTime" slot-scope="text">
            {{ text | formatTime('YYYY-MM-DD HH:mm:ss') }}
          </span>
          <span slot="action" slot-scope="text, recrod">
            <a-button v-if="recrod.isSupportCancel === 'Y'" type="primary" size="small" @click="handleCancel(recrod)">取消值机</a-button>
            <span v-else>-</span>
          </span>
        </a-table>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
#checkinRecord {
  .checkin-wrap {
    padding-top: 30px;
    .ant-form-item {
      width: 100%;
      margin-bottom: 10px;
    }
  }
  .loading {
    width: 100%;
    text-align: center;
  }
}
@media only screen and (max-width: 768px) {
  #checkinRecord {
    .checkin-wrap {
      padding-top: 15px;
    }
  }
}
</style>
<script>
import { omitBy } from 'lodash'
import CheckInTab from '@/components/checkin/checkInTab'
import getAppInfo from '@/utils/from'
import { format } from '@/filters/time'
import { validate } from '@/assets/js/validate'
import { flightCities } from '@/assets/js/data'
import { queryCheckinRecord, checkinCancel } from '@/apis/checkin'
import './index'

const columns = [
  {
    key: 'ticketNo',
    title: '票号',
    dataIndex: 'ticketNo',
    align: 'center'
  },
  {
    key: 'passengerName',
    title: '旅客姓名',
    dataIndex: 'passengerName',
    align: 'center'
  },
  {
    key: 'depName',
    title: '出发城市',
    dataIndex: 'depName',
    align: 'center'
  },
  {
    key: 'arrName',
    title: '到达城市',
    dataIndex: 'arrName',
    align: 'center'
  },
  {
    key: 'flightNo',
    title: '航班号',
    dataIndex: 'flightNo',
    align: 'center'
  },
  {
    key: 'seatNo',
    title: '座位号',
    dataIndex: 'seatNo',
    align: 'center'
  },
  {
    key: 'boardingTime',
    title: '登机时间',
    dataIndex: 'boardingTime',
    scopedSlots: { customRender: 'boardingTime' },
    align: 'center'
  },
  {
    key: 'action',
    title: '操作',
    dataIndex: 'action',
    scopedSlots: { customRender: 'action' },
    align: 'center'
  }
]

export default {
  data () {
    return {
      tabInit: '4',
      form: this.$form.createForm(this),
      labelWidth: 6,
      wrapWidth: 16,
      columns,
      data: {
        list: [],
        pagination: {
          current: 1,
          pageSize: 10,
          total: 0
        }
      },
      loading: false,
      isSearch: false,
      ticketCode: getAppInfo()?.ticketCode,
      citiesData: []
    }
  },
  created () {
    this.getData()
    this.fetch()
    window.__MICRO_ROOT__?.api?.track?.('checkin_record')
  },
  methods: {
    async getData () {
      const cities = await flightCities()

      if (cities) {
        this.citiesData = cities
      }
    },
    onDepCodeChange (value) {
      this.form.setFieldsValue({
        depCode: value
      })
    },
    handleSubmit (e) {
      e && e.preventDefault()

      this.form.validateFields((err) => {
        if (!err) {
          this.$set(this.data.pagination, 'current', 1)
          this.fetch()
        }
      })
    },
    fetch () {
      const params = {
        page: this.data.pagination.current,
        pageSize: this.data.pagination.pageSize
      }
      this.search(params)
    },
    onChange (pagination) {
      const { page, pageSize } = pagination

      this.search({
        page,
        pageSize
      })
    },
    async search (params) {
      this.isSearch = true
      this.loading = true
      try {
        const formValues = omitBy(this.form.getFieldsValue(), v => !v)
        const data = await queryCheckinRecord({
          ...params,
          ...formValues
        })
        this.loading = false

        const { list = [], page = 1, pageSize, totalElements = 0 } = data
        this.data = {
          list: list || [],
          pagination: {
            current: page,
            pageSize,
            total: totalElements
          }
        }
      } catch (e) {
        this.loading = false
        this.data = {
          list: [],
          pagination: {
            current: 1,
            pageSize: 10,
            total: 0
          }
        }
        this.$message.error(e.message)
      }
    },
    handleFieldValidate (rule, value, callback) {
      const formValues = this.form.getFieldsValue()
      validate('checkinRecrod', formValues, rule.fullField).then(({ valid, errors }) => {
        if (valid) {
          callback && callback()
        } else {
          callback(errors[0].message)
        }
      })
    },
    handleCancel (item) {
      this.$modal.confirm({
        title: '提示',
        content: '是否确认取消值机？',
        cancelText: '取消',
        okText: '确认',
        onOk: async () => {
          const params = {
            airlineCode: item.airCode,
            arrCode: item.arrCode,
            depCode: item.depCode,
            depTime: item.flightDateDep,
            flightNo: item.flightNo,
            ticketNo: item.ticketNo,
            passengerName: item.passengerName,
            seatNumber: item.seatNo
          }

          try {
            await checkinCancel(params)
            this.$message.success('取消值机操作成功！').then(() => {
              this.$set(this.data.pagination, 'current', 1)
              this.fetch()
            })
          } catch (err) {
            this.$message.error(err.message)
          }
        }
      })
    }
  },
  filters: {
    formatTime: format
  },
  components: {
    CheckInTab
  }
}
</script>
